import timezones from "timezones.json";
import { SelectItemType } from "@evvve/ui-kit/dist/components/Select/SelectItemType";

export const timezoneItems: SelectItemType[] = timezones.map((tz) => ({
  label: tz.text,
  value: tz.value,
}));
